'use client';

import { useState } from 'react';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Button from '@/components/@base/button';
import { VARIANT_ENUM } from '@/components/@base/button/type';
import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';
import { PromoteVideo } from '@/components/app/product/components/promote-video';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function PromoteVideoBtn({
  promoteVideo,
  promoteVideoCover,
}: {
  promoteVideo: any;
  promoteVideoCover?: any;
}) {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <Container className='mb-[11px] border-b border-dashed border-[#0000001A] pr-1 pb-[9px]! md:-mt-4!'>
      <Button
        id='promote-video-btn'
        onClick={() => setShowVideo(true)}
        variant={VARIANT_ENUM.SOUL}
        size={SIZE_ENUM.SM}
        className='font-extra-bold flex items-center justify-start border-none! bg-transparent! px-0! text-sm tracking-tighter! whitespace-nowrap text-[#757C87] shadow-none! hover:text-[#757C87]'
      >
        <div className='relative ml-2.5 flex h-7 w-7 items-center justify-center'>
          <div className='animate-ping-slow-small absolute inset-0 z-0 rounded-full bg-[linear-gradient(180deg,#FEA000_0%,#FF6B01_100%)]'></div>
          <div className='relative z-10 flex h-7 w-7 items-center rounded-full bg-[linear-gradient(180deg,#FEA000_10%,#FF6B01_100%)]'>
            <XImage
              src={imagesList?.icons?.play}
              alt='play'
              width={9}
              height={9}
              className='mr-[8px]'
            />
          </div>
        </div>
        <div className='font-[500]! tracking-[-0.05em]! text-[#757C87] hover:text-[#EB8800]'>
          {productLocalization.productVideo}
        </div>
      </Button>
      {showVideo && (
        <PromoteVideo
          isOpen={showVideo}
          onCloseAction={() => setShowVideo(false)}
          promoteVideo={promoteVideo}
          promoteVideoCover={promoteVideoCover}
        />
      )}
    </Container>
  );
}
